import {
  CustomDocumentTypeModel,
  EntityTypeEnum,
} from '../../../shared/models';

export type DefaultCustomDocumentTypeConfig = Pick<
  CustomDocumentTypeModel,
  | 'label'
  | 'key'
  | 'isInternal'
  | 'targetEntities'
  | 'analysisInstruction'
  | 'automaticApproval'
  | 'automaticRejection'
  | 'fraudAnalysis'
>;

export const DEFAULT_CUSTOM_DOCUMENT_TYPES: DefaultCustomDocumentTypeConfig[] =
  [
    {
      label: 'Signed Corporate Structure Chart',
      key: 'signed_corporate_structure_chart',
      isInternal: false,
      targetEntities: [EntityTypeEnum.company],
      analysisInstruction: null,
      automaticApproval: false,
      automaticRejection: false,
      fraudAnalysis: null,
    },
    {
      label: 'Bank Statements',
      key: 'bank_statement',
      isInternal: false,
      targetEntities: [EntityTypeEnum.individual],
      analysisInstruction: null,
      automaticApproval: false,
      automaticRejection: false,
      fraudAnalysis: null,
    },
  ];
